import Android from "../img/review/ANDROID.png";
import ios from "../img/review/iOS.png";
import app from "../img/review/APP.png";
import web from "../img/review/WEB.png";
// import html5 from "../img/review/html5.png";

import avatar1 from "../img/review/AvatarreviewImg-1.png";
import avatar2 from "../img/review/AvatarreviewImg-2.png";
import avatar3 from "../img/review/AvatarreviewImg-3.png";
import avatar4 from "../img/review/AvatarreviewImg-4.png";

export const ReviewData = [
  {
    id: 1,
    image: avatar1,
    name: "H사",
    types: [Android, app],
    title: "핸드 드립 추출 IoT제어 시스템",
    longText: `개발을 편하게 진행할 수 있어서 매우 만족스러웠습니다.
친절한 소통은 물론, 요청드린 수정 사항도 신속하게 반영해주셔서 감사했습니다.
약속하신 일정도 정확히 지켜주셔서 신뢰가 더욱 깊어졌습니다. 이처럼 실력 있고 성실한 개발자분이 더 많은 분들께 알려졌으면 좋겠습니다.`,
    os: "안드로이드",
    developmentType: "앱",
    description: "머신 자동 제어, 나만의 레시피 만들기 등",
    link: "https://blog.naver.com/datafive/223902030272",
  },
  {
    id: 2,
    image: avatar2,
    name: "E사",
    types: [ios, Android, app],
    title: "할인 정보 제공 캘린더 앱",
    longText: `처음으로 의뢰드린 프로젝트였지만, 매우 친절하게 소통해 주시고 원하는 방향대로 개발해 주셔서 만족스러운 결과를 얻었습니다.
앞으로 추가 운영이나 개발이 필요할 경우, 다시 의뢰드릴 예정입니다.`,
    os: "안드로이드,iOS,Linux 서버(AWS)",
    developmentType: "앱, 웹(관리자페이지)",
    description: "할인 일정 정보 제공, 장바구니 등",
    link: "https://blog.naver.com/datafive/223960880729",
  },
  {
    id: 3,
    image: avatar3,
    name: "U사",
    types: [ios, Android, app],
    title: "학원 수업 관리 앱",
    longText: `책임감 있게 끝까지 프로젝트에 임해주셔서 매우 감사드립니다.
중간중간 소통도 원활하게 해주시고, 문제 발생 시 신속하게 대응해 주셔서 신뢰가 컸습니다.
덕분에 안심하고 프로젝트를 진행할 수 있었습니다.`,
    os: "안드로이드,iOS,Linux 서버(AWS)",
    developmentType: "앱, 웹(관리자페이지)",
    description: "강의 스케줄 관리, 셔틀 탑승 관리, 이력 관리 등",
    link: "https://blog.naver.com/datafive/223712926457",
  },
  {
    id: 4,
    image: avatar4,
    name: "H사",
    types: [web],
    title: "Modbus 기반 대시보드 개발",
    longText: `처음 의뢰하는 프로젝트라 걱정했지만, 디자인과 개발 결과물 모두 매우 만족스러웠습니다. 현실적인 방향 제시와 신속한 대응 덕분에 원활하게 진행할 수 있었습니다. 
늦은 시간 문의에도 친절히 응대해 주시고, 놓친 기능도 먼저 찾아 제안해 주셔서 감사드립니다. 파트너처럼 함께 문제를 해결하며 성실히 임해 주셔서 매우 감사했습니다.`,
    os: "기타(윈도우 11)",
    developmentType: "웹(관리자페이지)",
    description:
      "대시보드(센서 데이터 수집), 데이터 기간별 조회 및 엑셀 다운로드",
    link: "https://blog.naver.com/datafive/223942657017",
  },
  //   {
  //   id: 1,
  //   image: avatar1,
  //   name: "",
  //   types: [],
  //   title: "",
  //   longText: ``,
  //   os: "",
  //   developmentType: "",
  //   description: "",
  //   link: "",
  // },
];
